// extracted by mini-css-extract-plugin
export var flip = "Icon-module--flip--bf72c";
export var icon = "Icon-module--icon--6c9a3";
export var large = "Icon-module--large--6de83";
export var medium = "Icon-module--medium--0b0a8";
export var small = "Icon-module--small--67d6e";